<i18n lang="yaml">
en:
  signIn: 'Log in'
  registration: 'Sign up'
  speed: 'Network speed test'
  support: 'Support'
ru:
  signIn: 'Войти'
  registration: 'Зарегистрироваться'
  speed: 'Скорость сети'
  support: 'Поддержка'
</i18n>

<template>
  <nav
    class="main-nav"
    :class="{ 'main-nav--locked' : openedMenu}"
    v-body-scroll-lock:reserveScrollBarGap="openedMenu && $nuxt.$breakpoints.lLg"
  >
    <ul
      class="main-nav__list"
      @mouseleave="closeGroupMenu($nuxt.$breakpoints.xl)"
    >
      <li
        v-for="(group, i) in menu"
        :key="i"
        class="main-nav__list-item"
      >
        <button
          class="main-nav__list-btn"
          :class="{'main-nav__list-btn--active' : group.primaryKey === openedMenu}"
          type="button"
          @mouseover="openedGroupMenu(group.primaryKey, $nuxt.$breakpoints.xl)"
          @click="openedGroupMenu(group.primaryKey, $nuxt.$breakpoints.sLg)"
        >
          {{ group.title }}

          <svg-right-arrow-icon
            class="main-nav__list-btn-icon main-nav__list-btn-icon--right-arrow"></svg-right-arrow-icon>
          <svg-arrow-icon class="main-nav__list-btn-icon main-nav__list-btn-icon--arrow"></svg-arrow-icon>
        </button>

        <submenu
          class="main-nav__dropdown"
          :class="{'main-nav__dropdown--visible' : openedMenu === group.primaryKey}"
          :submenu="group.submenu"
          :group-menu-title="group.title"
          :is-nav-opened="isNavOpened"
          @closeGroupMenu="closeGroupMenu($nuxt.$breakpoints.sLg)"
          @closeMenu="closeMenu"
        ></submenu>
      </li>
    </ul>

    <template v-if="$nuxt.$breakpoints.sLg">
      <div class="main-nav__control-panel">
        <control-panel-icon></control-panel-icon>
        <a
          href="https://my.selectel.ru/login"
          rel="noopener noreferrer"
          target="_blank"
        >
          {{ $t('signIn') }}
        </a>
        &nbsp;/&nbsp;
        <a
          href="https://my.selectel.ru/registration"
          rel="noopener noreferrer"
          target="_blank"
        >
          {{ $t('registration') }}
        </a>
      </div>
      <ul class="main-nav__additional-list">
        <li class="main-nav__additional-item">
          <nuxt-link
            :to="switchLocalePath($i18n.locale === 'ru' ? 'en' : 'ru')"
            class="main-nav__additional-link"
          >
            <span @click="closeMenu">
              <planet-icon></planet-icon>
              {{ $i18n.locale === 'ru' ? 'English' : 'Русский' }}
            </span>
          </nuxt-link>
        </li>
        <li class="main-nav__additional-item">
          <a
            class="main-nav__additional-link main-nav__additional-link-status"
            :class="`main-nav__additional-link-status--${statusPanel}`"
            href="http://status.selectel.info/"
            rel="noopener noreferrer"
            target="_blank"
            @click="closeMenu"
          >
            {{ statusPanelMessage[$i18n.locale] }}
          </a>
        </li>
        <li class="main-nav__additional-item">
          <a
            class="main-nav__additional-link"
            href="https://speedtest.selectel.ru/"
            rel="noopener noreferrer"
            target="_blank"
            @click="closeMenu"
          >
            <lan-speed-icon></lan-speed-icon>
            {{ $t('speed') }}
          </a>
        </li>
        <li class="main-nav__additional-item">
          <a
            class="main-nav__additional-link"
            href="mailto:sales@selectel.ru"
            data-gtmid="gtm-selectel-mailto-click"
            @click="closeMenu"
          >
            <mail-icon></mail-icon>
            sales@selectel.ru
          </a>
        </li>
        <li class="main-nav__additional-item">
          <a
            class="main-nav__additional-link"
            href="https://t.me/SelectelTgbot"
            data-gtmid="gtm-selectel-telegram-click"
            @click="closeMenu"
          >
            <telegram-icon></telegram-icon>
            {{ $t('support') }}
          </a>
        </li>
        <li class="main-nav__additional-item">
          <a
            class="main-nav__additional-link"
            href="tel:88005550675"
            data-gtmid="gtm-selectel-call-click"
            @click="closeMenu"
          >
            <svg-phone></svg-phone>
            8&nbsp;800&nbsp;555&nbsp;06&nbsp;75
          </a>
        </li>
      </ul>

    </template>

    <portal to="overlay">
      <s-overlay
        v-if="$nuxt.$breakpoints.lLg"
        class="main-nav__overlay"
        :class="{'overlay--shown' : openedMenu}"
        @closeOverlay="closeOverlay"
      ></s-overlay>
    </portal>
  </nav>
</template>

<script>
import SvgArrowIcon from '~/assets/icons/header/arrow.svg'
import SvgRightArrowIcon from '~/assets/icons/header/dropdown-menu/right-arrow.svg'
import Submenu from './SubMenu'
import PlanetIcon from '~/assets/icons/header/planet.svg'
import LanSpeedIcon from '~/assets/icons/header/lan-speed.svg'
import MailIcon from '~/assets/icons/header/mail.svg'
import TelegramIcon from '~/assets/icons/header/telegram.svg'
import SvgPhone from '~/assets/icons/header/dropdown-menu/phone.svg'
import ControlPanelIcon from '~/assets/icons/header/control-panel.svg'
import {mapGetters} from 'vuex'

export default {
  name: 'Menu',
  components: {
    SvgArrowIcon,
    SvgRightArrowIcon,
    Submenu,
    PlanetIcon,
    LanSpeedIcon,
    MailIcon,
    TelegramIcon,
    SvgPhone,
    ControlPanelIcon
  },
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    isNavOpened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openedMenu: null
    }
  },
  computed: {
    ...mapGetters('modules/status-panel', ['statusPanelMessage', 'statusPanel'])
  },
  watch: {
    isNavOpened() {
      if (this.isNavOpened === false) this.openedMenu = null
    }
  },
  methods: {
    openedGroupMenu(key, isBreakpoint = true) {
      if (!isBreakpoint) return

      this.openedMenu = this.openedMenu === key
        ? null
        : key
    },
    closeGroupMenu(isBreakpoint = true) {
      if (!isBreakpoint) return

      if (this.openedMenu) this.openedMenu = null
    },
    closeMenu() {
      this.openedMenu = null
      this.$emit('close')
    },
    closeOverlay() {
      this.openedMenu = null
    }
  }
}
</script>

<style lang="scss" scoped>
.main-nav {
  @media (min-width: $breakpoint-lg + 1) {
    display: block !important;
  }

  @media (max-width: $breakpoint-lg) {
    position: fixed;
    top: 49px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-bottom: 60px;
    border-top: 1px solid $primary10;
    overflow: hidden;
    overflow-y: auto;
    font-size: 16px;
  }

  @media (max-width: $breakpoint-md) {
    padding-bottom: 32px;
  }

  &--locked {
    overflow-y: hidden;
  }
}

.main-nav__overlay {
  transition-delay: 0.2s;

  &.overlay--shown {
    transition-delay: 0s;
  }
}

.main-nav__list {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 24px;
  grid-template-columns: max-content;
  justify-content: start;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: $breakpoint-xl) {
    grid-column-gap: 12px;
  }

  @media (max-width: $breakpoint-lg) {
    display: flex;
    flex-direction: column;
  }
}

.main-nav__list-item {
  padding: 5px 0 7px;

  @media (max-width: $breakpoint-lg) {
    padding: 0;
  }
}

.main-nav__list-btn {
  position: relative;
  display: block;
  border: none;
  padding-right: 24px;
  padding-left: 4px;
  border-radius: 2px;
  background-color: transparent;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease-in;

  @media (max-width: $breakpoint-xl) {
    padding-right: 4px;
  }

  @media (max-width: $breakpoint-lg) {
    width: 100%;
    padding: 16px 42px 16px 10px;
    border-bottom: 1px solid $primary10;
  }

  &:hover,
  &:focus {
    @media (min-width: $breakpoint-xl + 1) {
      border-radius: 2px;
      background-color: transparentize($primary, 0.9);
    }
  }

  &:focus {
    outline: none;
  }

  &--active {
    border-radius: 2px;
    background-color: transparentize($primary, 0.9);

    @media (max-width: $breakpoint-lg) {
      border-radius: 0;
      background-color: #FFF;
    }
  }

  &--active .main-nav__list-btn-icon {
    transform: translateY(-50%) rotate(180deg);

    @media (max-width: $breakpoint-lg) {
      transform: none;
    }
  }
}

.main-nav__list-btn-icon {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  width: 14px;
  height: 9px;
  transition: 0.2s ease-in-out;
  pointer-events: none;

  &--right-arrow {
    display: none;

    @media (max-width: $breakpoint-lg) {
      top: 1.25em;
      right: 10px;
      transform: none;
      display: block;
      width: 16px;
      height: 16px;
    }
  }

  &--arrow {
    display: block;

    @media (max-width: $breakpoint-xl) {
      display: none;
    }
  }
}

.main-nav__control-panel {
  display: none;

  @media (max-width: $breakpoint-lg) {
    display: flex;
    align-items: center;
    padding: 16px 10px;
    border-bottom: 1px solid $primary10;
    color: $primary;
  }

  a {
    text-decoration: underline;
    color: inherit;
  }

  svg {
    width: 16px;
    max-height: 16px;
    margin-right: 8px;
  }
}

.main-nav__dropdown {
  z-index: 99;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 0;
  opacity: 0;
  visibility: hidden;
  background-color: #FFF;
  border-top: 1px solid $primary10;
  border-bottom: 1px solid $primary10;
  transition: 0.2s 0.2s;

  @media (max-width: $breakpoint-lg) {
    position: fixed;
    top: 49px;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(100%);
    width: 100%;
    height: 100%;
    max-height: none;
    transition-delay: 0s;
  }

  &--visible {
    max-height: 80vh;
    opacity: 1;
    visibility: visible;
    transition: 0.2s 0s;

    @media (max-width: $breakpoint-lg) {
      transform: translateX(0);
      max-height: none;
      transition-delay: 0s;
    }
  }
}

.main-nav__additional-list {
  display: none;
  grid-auto-flow: row;
  grid-row-gap: 10px;
  margin-bottom: 0;
  padding: 15px 10px;
  list-style: none;

  @media (max-width: $breakpoint-lg) {
    display: grid;
    grid-row-gap: 16px;
    padding-top: 40px;

    & > * {
      min-width: 0;
    }
  }
}

.main-nav__additional-link {
  color: $primary;
  transition: color 0.2s;

  &:hover,
  &:focus {
    color: $secondary;
  }

  @media (max-width: $breakpoint-lg) {
    display: inline-flex;
    align-items: center;

    svg {
      width: 14px;
      max-height: 14px;
      margin-right: 6px;
      transition: fill 0.2s;
    }
  }
}

.main-nav__additional-link-status {
  padding-left: 20px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;

  background-image: url('~@/assets/icons/single/status-panel/success.svg?inline');
  background-size: 8px 8px;
  background-repeat: no-repeat;
  background-position: left 3px center;
}

.main-nav__additional-link-status--warn {
  background-image: url('~@/assets/icons/single/status-panel/warn.svg?inline');
}

.main-nav__additional-link-status--error {
  background-image: url('~@/assets/icons/single/status-panel/error.svg?inline');
}

.main-nav__additional-link-status--alert {
  background-image: url('~@/assets/icons/single/status-panel/alert.svg?inline');
}
</style>